import { render, staticRenderFns } from "./Pmix.vue?vue&type=template&id=72f87c20&scoped=true"
import script from "./Pmix.vue?vue&type=script&lang=js"
export * from "./Pmix.vue?vue&type=script&lang=js"
import style0 from "./Pmix.vue?vue&type=style&index=0&id=72f87c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f87c20",
  null
  
)

export default component.exports